import { type RouteRecordRaw, RouterView } from 'vue-router';
// import { route as homeRoute } from '@centric-os/home';
import { route as brandsRoute } from '@centric-os/global-menu-groups';
import { route as discoverRoute } from '@centric-os/discover';
import { route as menusRoute } from '@centric-os/local-menu-groups';
import { route as loginRoute } from '@centric-os/login';
import { route as ordersRoute } from '@centric-os/orders';
import { route as reportsRoute } from '@centric-os/reports';
import { route as sitesRoute } from '@centric-os/sites';
import { route as scannerRoute } from '@centric-os/scanner';
import { route as librariesRoute } from '@centric-os/libraries';
import { route as forecastingRoute } from '@centric-os/forecasting';
import { route as stockRoute } from '@centric-os/stock';
import { route as inventoryRoute } from '@centric-os/inventory';
// Announcements Routes
import { route as announcementsRoutes } from '@centric-os/announcements';

// Discount Routes
import { route as discountsRoutes } from '@centric-os/discounts';

// Labs Routes
import { route as labsRoute } from '@centric-os/labs';

// Admin Panel Routes
import { route as ap3UsersRoute } from '@ap3/user-management';

import { createRouter } from '@centric-os/platform/router';
import { RootRouteNames, RootRoutePathNames } from '../enums';
import authGuard from './guards/auth';
import { appcuesIdentify, appcuesGuard } from './guards/app-cues';

const MainContent = async () => {
  const module = await import('./../components/main-content');
  return module.MainContent;
};

export const experimentRoutes: RouteRecordRaw[] = [
  {
    path: RootRoutePathNames.ROOT,
    name: RootRouteNames.ROOT,
    component: RouterView,
    children: [
      loginRoute,
      {
        path: '',
        name: RootRouteNames.MAIN,
        component: MainContent,
        redirect: () => {
          return sitesRoute.path;
        },
        children: [
          // homeRoute,
          discoverRoute,
          sitesRoute,
          ordersRoute,
          reportsRoute,
          brandsRoute,
          menusRoute,
          scannerRoute,
          librariesRoute,
          forecastingRoute,
          stockRoute,
          inventoryRoute,

          // Announcements Routes
          announcementsRoutes,

          // Discount Routes
          discountsRoutes,

          // Labs Routes
          labsRoute,

          // Admin Panel Routes
          ap3UsersRoute,
        ],
      },
    ],
  } as RouteRecordRaw,
];

export const router = createRouter(experimentRoutes);

router.beforeEach(authGuard);
router.beforeEach(appcuesGuard);
router.afterEach(appcuesIdentify);
